import { render, staticRenderFns } from "./DistributorRegistration.vue?vue&type=template&id=7723e703&"
import script from "./DistributorRegistration.vue?vue&type=script&lang=js&"
export * from "./DistributorRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports